<div class="flex flex-col">
  <!-- Header -->
  <div class="px-6 pt-4 pb-2">
    <div class="flex justify-between items-center">
      <div>
        <h1 class="text-2xl font-bold text-gray-800">Funcionários</h1>
        <p class="text-sm text-gray-500">Gerencie os funcionários cadastrados</p>
      </div>
      <button
        (click)="createEmployee()"
        class="bg-orange-500 hover:bg-orange-600 cursor-pointer text-white px-4 py-2 rounded"
      >
        Novo Funcionário
      </button>
    </div>
  </div>

  <!-- Filtros -->
  <div class="px-6 py-4 bg-white shadow shrink-0 z-10">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div class="flex flex-col">
        <label class="text-sm font-medium text-gray-700 mb-1">Buscar</label>
        <input
          pInputText
          type="text"
          [(ngModel)]="searchTerm"
          (input)="applyFilters()"
          placeholder="Digite o nome do funcionário..."
          class="w-full text-sm"
        />
      </div>
      <div class="flex flex-col">
        <label class="text-sm font-medium text-gray-700 mb-1">Status</label>
        <p-dropdown
          [options]="statusOptions"
          [(ngModel)]="activeFilter"
          (onChange)="applyFilters()"
          optionLabel="label"
          optionValue="value"
          placeholder="Selecione o status"
          class="w-full text-sm"
        ></p-dropdown>
      </div>
    </div>
  </div>

  <!-- Tabela -->
  <div class="flex-1 overflow-y-auto px-6 py-4 bg-gray-50">
    <div class="bg-white shadow rounded overflow-x-auto">
      <p-table
        [value]="employees"
        [paginator]="false"
        [loading]="loading"
        styleClass="p-datatable-sm"
        [rowHover]="true"
        [stripedRows]="true"
        stripedRowsClass="bg-orange-50"
        [showCurrentPageReport]="false"
        responsiveLayout="scroll"
        class="min-w-full text-sm"
      >
        <ng-template pTemplate="header">
          <tr class="bg-gray-100">
            <th class="text-left px-6 py-3">Código</th>
            <th class="text-left px-6 py-3">Nome</th>
            <th class="text-left px-6 py-3">Status</th>
            <th class="text-left px-6 py-3">Ações</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-employee let-i="rowIndex">
          <tr [ngClass]="i % 2 === 0 ? 'bg-white' : 'bg-orange-50'">
            <td class="px-6 py-2 font-mono">{{ employee.id }}</td>
            <td class="px-6 py-2 font-semibold text-gray-900">{{ employee.fullName }}</td>
            <td class="px-6 py-2">
              <span
                class="px-2 py-1 rounded-full text-xs"
                [ngClass]="{
                  'bg-green-100 text-green-800': employee.active,
                  'bg-red-100 text-red-800': !employee.active
                }"
              >
                {{ employee.active ? 'Ativo' : 'Inativo' }}
              </span>
            </td>
            <td class="px-6 py-2">
              <div class="flex space-x-2">
                <p-button
                  pTooltip="Editar"
                  icon="pi pi-pencil"
                  text
                  severity="secondary"
                  (click)="edit(employee)"
                ></p-button>
                <p-button
                  pTooltip="Excluir"
                  icon="pi pi-trash"
                  text
                  severity="danger"
                  (click)="delete(employee)"
                ></p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="4" class="text-center py-8 text-gray-500">
              Nenhum funcionário encontrado
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <!-- Paginator -->
    <div class="flex justify-center py-4">
      <p-paginator
        [first]="first"
        [rows]="rows"
        [totalRecords]="totalRecords"
        (onPageChange)="onPageChange($event)"
        [showCurrentPageReport]="true"
        [showPageLinks]="true"
        [showFirstLastIcon]="true"
        styleClass="custom-paginator"
      ></p-paginator>
    </div>
  </div>
</div>
